export const selectAccessories = [
  {
    path: `/SelectAccessories`,
    name: `SelectAccessories`,
    redirect: `/SelectAccessories/add`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/SelectAccessories/add/:subId/:groupId/:projectId/:groupName/:isService',
        name: '/SelectAccessories/add',
        component: () => import('@/views/selectaccessories/SelectAccessories')
      }
    ]
  }
];
